import identificate from '../../containers/client/identificate';
import {
  CATALOG_POLICY,
  VALIDATE_TOKEN_CLIENT,
  VALIDATE_TOKEN_CLIENT_MOBILE,
  CLIENTS_RECEIPT_RFC,
  PERSIST_DATA_POLICY,
  CLIENTS_RECEIPT_CUSTOMER,
  CLEAR_RECEIPTS
} from '../actions/clientActions';

const initialState = {
  catalog: [],
  clientToken: null,
  clientTokenMobile: null,
  policyData: null,
  receipts: [],
  identificate: false
}; // END initialState

export default function (state = initialState, action) {
  let { payload } = action;
  switch (action.type) {
    case CATALOG_POLICY:
      return {
        ...state,
        catalog: payload.data
      };
    case VALIDATE_TOKEN_CLIENT:
      return { ...state, clientToken: payload.access_token };
    case VALIDATE_TOKEN_CLIENT_MOBILE:
      return { ...state, clientTokenMobile: payload.access_token };
    case CLIENTS_RECEIPT_RFC:
      return { ...state, receipts: payload, identificate: false };
    case PERSIST_DATA_POLICY:
      return { ...state, policyData: payload };
    case CLIENTS_RECEIPT_CUSTOMER:
      return { ...state, receipts: payload, identificate: true };
    case CLEAR_RECEIPTS:
      return { ...state, receipts: [], identificate: false };
    default:
      return state;
  }
} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/clientReducer.js